import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import buyoutDeposit from '../../../js/stores/buyout-deposit.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var saveBuyoutDeposit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var formBuyoutDeposit, result;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formBuyoutDeposit = $f7.form.convertToData('#buyout-deposit-form');
            _context2.next = 1;
            return buyoutDeposit.dispatch('modifyData', formBuyoutDeposit);
          case 1:
            result = _context2.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context2.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context2.abrupt("return");
          case 2:
            if (!(Number(result) > 0)) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return $f7.emit('fillDashboardGrid');
          case 3:
            $f7.toast.show({
              text: 'Option saved'
            });
            _context2.next = 5;
            break;
          case 4:
            console.log("Option not saved");
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveBuyoutDeposit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var createBuyoutDeposit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var formBuyoutDeposit, result;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return");
          case 1:
            result = _context3.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context3.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context3.abrupt("return");
          case 2:
            if (Number(result) > 0) {
              $f7.toast.show({
                text: 'Option created'
              });
            } else {
              console.log("Option not created");
            }
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function createBuyoutDeposit() {
      return _ref4.apply(this, arguments);
    };
  }();
  var changeBuyoutStatus = function changeBuyoutStatus(e) {
    document.getElementById('buyout-deposit-status-id').value = e.target.checked ? 1 : 0;
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup buyout-deposit-popup">
  <div class="view">
    <div class="page" data-name="car-buyout-deposit-edit">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('general.edit')}</div>
          <div class="right">
            <a class="link popup-close">
              <i class="icon material-symbols-outlined color-red">cancel</i>
            </a>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="block-title">${locale.translate('admin.sections.buyoutDeposit.editTitle')}</div>
        <div class="block block-strong">
          <form id="buyout-deposit-form" class="list">
            <input id="buyout-deposit-id" name="BuyoutDepositId" type="hidden" value="${props.BuyoutDepositId}" />
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.buyoutDeposit.feeLabel')} €</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <input id="buyout-deposit-fee" name="BuyoutDepositFee" type="number" value="${props.BuyoutDepositFee}" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${locale.translate('admin.sections.buyoutDeposit.toPayLabel')} €</div>
                    <div class="item-input-wrap">
                      <input id="buyout-deposit-to-pay" name="BuyoutDepositToPay" type="number" value="${props.BuyoutDepositToPay}" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${locale.translate('admin.sections.buyoutDeposit.displayMessageLabel')}:</div>
                    <div class="item-input-wrap">
                      <input id="buyout-deposit-recommendation-label" name="BuyoutDepositRecommendationLabel" value="${props.BuyoutDepositRecommendationLabel}" type="text" placeholder="" autocomplete="off"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <label class="item-content">
                  <div class="item-inner">
                    <div class="item-title">${locale.translate('admin.sections.buyoutDeposit.showOptionLabel')}</div>
                    <div class="item-after">
                      <div class="toggle toggle-init">
                        <input id="buyout-deposit-status-id" name="BuyoutDepositStatusId" type="hidden" value="${props.BuyoutDepositStatusId}" /> 
                        <input id="buyout-deposit-status-input" @change="${changeBuyoutStatus}" type="checkbox" checked="${props.BuyoutDepositStatusId > 0 && $h`checked`}" />
                        <span class="toggle-icon"></span>
                      </div>
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </form>
          <br />
          <div>
            <a href="#" class="button button-fill button-raised color-blue" @click="${saveBuyoutDeposit}">
              <span class="material-symbols-outlined">save</span>${locale.translate('general.save')}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '2a5a2d9066';
export default framework7Component;